export default "__VITE_ASSET__bqgjDWLR__"